import React from 'react';
import style from './header.module.scss';
import TopMenu from '../top-menu/top-menu';
import { IHeader } from '../../../models/header/IHeader';
import { HeaderLayout } from '../../../constants/header-layout';

export type Props = {
  headerProps: IHeader;
};

export default function Header({ headerProps }: Props) {
  return (
    <header className={style.header}>
      <TopMenu
        profile={headerProps?.profile}
        menuItems={headerProps?.menuItems}
        locales={headerProps?.localesList}
        isShowSearchBar={headerProps?.isShowSearchBar}
        applicationSettings={headerProps?.applicationSettings}
        currentLocale={headerProps?.currentLocale}
        pathname={headerProps?.pathname}
        brandLogo={headerProps?.brandLogo}
        brandLogoAltText={headerProps?.brandLogoAltText}
        brandLogoURL={headerProps?.brandLogoURL}
        themeColor={headerProps?.themeColor}
        themeCopyColor={headerProps?.themeCopyColor}
        invertedTheme={headerProps?.invertedTheme}
        brandPrimaryColor={headerProps?.brandPrimaryColor}
        headerApplyURL={headerProps?.headerApplyURL}
        headerApplyCopyText={headerProps?.headerApplyCopyText}
        headerSearchPlaceholder={headerProps?.headerSearchPlaceholder}
        isLargerLogo={headerProps.headerLayout === HeaderLayout.LargerLogo}
      />
    </header>
  );
}
